import React, { useState } from 'react';
import Layout from '../components/Layout';
import FAQ from '../components/FAQ';
import AIChatButton from '../components/AIChatButton';

const LegalInfo: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'about' | 'terms' | 'faq'>('about');

  const teamMembers = [
    {
      name: 'Prof',
      role: 'Lead Tutor',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/portrait-professional-elegant-businessman__7_-removebg-preview.png'
    },
    {
      name: 'Prince Okyere',
      role: 'Tutor-CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/Prince_Okyerewith-Background.png'
    },
    {
      name: 'Abigail Dadzie',
      role: 'Tutor - Oil and Gas / CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/Abigail_dadzie-with-Background.png'
    },
    {
      name: 'Prince Tetteh',
      role: 'Tutor-CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/business-person-futuristic-business-environment__2_-removebg-preview.png'
    },
    {
      name: 'Enock Sani',
      role: 'Tutor-CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/portrait-professional-elegant-businessman-removebg-preview.png'
    },
    {
      name: 'Thomas Ansah',
      role: 'Tutor-ICAG',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/Thomas_-removebg-preview.png'
    }
  ];

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Legal Information
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Learn more about Profs Training Solutions and our terms of service
            </p>
          </div>

          {/* Tab Navigation */}
          <div className="flex justify-center mb-12">
            <div className="bg-white rounded-lg shadow-lg p-2 flex space-x-2">
              <button
                onClick={() => setActiveTab('about')}
                className={`px-8 py-3 rounded-lg font-semibold transition-all duration-200 ${
                  activeTab === 'about'
                    ? 'bg-primary-600 text-white shadow-lg'
                    : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
                }`}
              >
                About Us
              </button>
              <button
                onClick={() => setActiveTab('terms')}
                className={`px-8 py-3 rounded-lg font-semibold transition-all duration-200 ${
                  activeTab === 'terms'
                    ? 'bg-primary-600 text-white shadow-lg'
                    : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
                }`}
              >
                Terms & Conditions
              </button>
              <button
                onClick={() => setActiveTab('faq')}
                className={`px-8 py-3 rounded-lg font-semibold transition-all duration-200 ${
                  activeTab === 'faq'
                    ? 'bg-primary-600 text-white shadow-lg'
                    : 'text-gray-600 hover:text-primary-600 hover:bg-primary-50'
                }`}
              >
                FAQ
              </button>
            </div>
          </div>

          {/* Content Sections */}
          {activeTab === 'about' && (
            <div className="space-y-16">
              {/* Hero Section */}
              <div className="text-center">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                  About Profs Training Solutions
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Make learning and teaching more effective with active participation and student collaboration.
                </p>
              </div>

              {/* Statistics Section */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                  <div className="text-4xl font-bold text-primary-600 mb-2">500</div>
                  <div className="text-lg font-semibold text-gray-800">Graduates</div>
                  <div className="text-gray-600">Successful Students</div>
                </div>
                <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                  <div className="text-4xl font-bold text-primary-600 mb-2">95%</div>
                  <div className="text-lg font-semibold text-gray-800">Success Rate</div>
                  <div className="text-gray-600">Pass Rate</div>
                </div>
                <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                  <div className="text-4xl font-bold text-primary-600 mb-2">50</div>
                  <div className="text-lg font-semibold text-gray-800">Excellence</div>
                  <div className="text-gray-600">Award Winners</div>
                </div>
              </div>

              {/* Mission & Vision Section */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-white rounded-lg shadow-lg p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Empowering individuals in Ghana to excel in the fields of accountancy and taxation by providing comprehensive, industry-focused education. We are dedicated to nurturing a learning environment that fosters critical thinking, ethical practices, and professional proficiency.
                  </p>
                </div>
                <div className="bg-white rounded-lg shadow-lg p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
                  <p className="text-gray-700 leading-relaxed">
                    To be the foremost educational institution in Ghana for accountancy and taxation, recognized for our commitment to excellence, innovation, and the holistic development of individuals.
                  </p>
                </div>
              </div>

              {/* Team Section */}
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                  Meet Our Expert Team
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {teamMembers.map((member, index) => (
                    <div key={index} className="text-center">
                      <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden shadow-lg">
                        <img
                          src={member.image}
                          alt={member.name}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.src = 'https://via.placeholder.com/128x128/6B7280/FFFFFF?text=' + member.name.charAt(0);
                          }}
                        />
                      </div>
                      <h4 className="text-xl font-semibold text-gray-900 mb-2">{member.name}</h4>
                      <p className="text-gray-600">{member.role}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Background Section */}
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-6 text-center">Our Background</h3>
                <div className="max-w-4xl mx-auto">
                  <p className="text-gray-700 leading-relaxed text-lg">
                    Led by a team of seasoned professors and industry experts, Profs Training Solutions is dedicated to equipping students with the knowledge, skills, and confidence needed to excel in the dynamic world of audit and assurance. With a track record of over 2000 successful students, our commitment to academic excellence and professional growth is unwavering.
                  </p>
                </div>
              </div>

              {/* Call to Action */}
              <div className="text-center">
                <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-lg shadow-lg p-8 text-white">
                  <h3 className="text-2xl font-bold mb-4">Ready to Start Your Journey?</h3>
                  <p className="text-lg mb-6">
                    Join hundreds of successful students who have transformed their careers with our expert-led programs.
                  </p>
                  <a
                    href="/signup"
                    className="inline-block bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200"
                  >
                    Get Started Today
                  </a>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'terms' && (
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                Terms and Conditions
              </h2>
              
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">
                  Welcome to Profs Training Solutions & Profstudyhub.com
                </h3>
              </div>

              {/* Quick Navigation */}
              <div className="bg-blue-50 rounded-lg p-6 mb-8">
                <h4 className="text-lg font-semibold text-blue-900 mb-4">Quick Navigation</h4>
                <ol className="list-decimal list-inside space-y-2 text-blue-800">
                  <li><a href="#course-content" className="hover:text-blue-600 underline">Course Content and Access</a></li>
                  <li><a href="#student-responsibilities" className="hover:text-blue-600 underline">Student Responsibilities</a></li>
                  <li><a href="#data-privacy" className="hover:text-blue-600 underline">Data Privacy</a></li>
                  <li><a href="#directives-expectations" className="hover:text-blue-600 underline">Directives and Expectations</a></li>
                  <li><a href="#course-engagement" className="hover:text-blue-600 underline">Course Engagement</a></li>
                  <li><a href="#modifications" className="hover:text-blue-600 underline">Modifications</a></li>
                  <li><a href="#contact-information" className="hover:text-blue-600 underline">Contact Information</a></li>
                </ol>
              </div>

              {/* Course Content and Access */}
              <section id="course-content" className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  1. Course Content and Access
                </h4>
                <div className="space-y-3 text-gray-700">
                  <p>All course content, including materials, lectures, and assessments, is the intellectual property of Profs.</p>
                  <p>Course Materials are for personal educational purposes only and must not be shared.</p>
                  <p>Access is granted until the relevant professional exam period for the current semester.</p>
                </div>
              </section>

              {/* Student Responsibilities */}
              <section id="student-responsibilities" className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  2. Student Responsibilities
                </h4>
                <div className="space-y-3 text-gray-700">
                  <p>Complete lessons according to the provided schedule.</p>
                  <p>Attend weekly online lectures via Zoom.</p>
                  <p>Participate in all assigned activities, projects, and mock exams.</p>
                </div>
              </section>

              {/* Data Privacy */}
              <section id="data-privacy" className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  3. Data Privacy
                </h4>
                <div className="text-gray-700">
                  <p>Your enrollment information is used solely for processing registration and training purposes.</p>
                </div>
              </section>

              {/* Directives and Expectations */}
              <section id="directives-expectations" className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  4. Directives and Expectations
                </h4>
                <div className="text-gray-700">
                  <p>Profs may issue directives to enhance exam preparation. Students must act responsibly during mentorship.</p>
                </div>
              </section>

              {/* Course Engagement */}
              <section id="course-engagement" className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  5. Course Engagement
                </h4>
                <div className="space-y-3 text-gray-700">
                  <p>Regular assignments are mandatory for participation in live discussions.</p>
                  <p>Repeated failure to complete assignments may result in disciplinary action.</p>
                </div>
              </section>

              {/* Modifications */}
              <section id="modifications" className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  6. Modifications
                </h4>
                <div className="text-gray-700">
                  <p>Profs reserves the right to modify these Terms at any time. Changes will be posted on the Platform.</p>
                </div>
              </section>

              {/* Contact Information */}
              <section id="contact-information" className="mb-8">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  7. Contact Information
                </h4>
                <div className="text-gray-700">
                  <p>
                    If you have any questions, contact us at{' '}
                    <a 
                      href="mailto:profstudymate@email.com" 
                      className="text-blue-600 hover:text-blue-800 underline"
                    >
                      profstudymate@email.com
                    </a>
                    .
                  </p>
                </div>
              </section>

              {/* Last Updated */}
              <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
                <p>Last updated: {new Date().toLocaleDateString()}</p>
              </div>
            </div>
          )}

          {activeTab === 'faq' && (
            <div className="bg-white rounded-lg shadow-lg p-8">
              <FAQ />
            </div>
          )}

          {/* AI Chat Button */}
          <AIChatButton />
        </div>
      </div>
    </Layout>
  );
};

export default LegalInfo;
